import { useSelector } from 'react-redux';

import { ca } from '@cian/analytics';
import { useDeviceType, TDeviceType } from '@cian/ui-kit';

import { getAuthor } from '../../selectors/author';
import { getPageviewObject } from '../../utils/getPageviewObject';
import { EPageTypes } from '../../constants/page';
import { useGetPlatform } from '../../utils/useGetPlatform';
import { EPlatform } from '@cian/webview/shared';

export interface ITrackPreviewReportOpenParams {
  userId?: number;
  deviceType: TDeviceType;
  platform: EPlatform | null;
}

export function trackPreviewReportOpen({ userId, deviceType, platform }: ITrackPreviewReportOpenParams) {
  ca('pageview', {
    name: 'newpage',
    category: 'page',
    action: 'newpage',
    label: 'open',
    ...getPageviewObject({ userId, deviceType, platform, pageType: EPageTypes.EstateCalculatorB2BPreview }),
  });
}

export function useTrackPreviewReportBack() {
  const deviceType = useDeviceType();
  const { realtyUserId: userId } = useSelector(getAuthor);
  const platform = useGetPlatform();

  return () => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'EstateCalculatorB2BPreview',
      action: 'Click',
      label: 'back',
    });

    const { page } = getPageviewObject({ userId, deviceType, platform, pageType: EPageTypes.EstateCalculatorB2B });

    /**
     * Подменяем page на актуальный для редактируемой страницы отчета,
     * без отправки повторного pageview события
     */
    ca('page', page);
  };
}

export function trackReportSend() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculatorB2B',
    action: 'Click_SendToClient_block',
    label: 'next',
  });
}
